
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface WebhookHeaderProps {
  lastUpdated: Date;
  loading: boolean;
  onRefresh: () => void;
}

export const WebhookHeader = ({ lastUpdated, loading, onRefresh }: WebhookHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div>
        <h2 className="text-2xl font-bold">httpSMS Webhook Events Monitor</h2>
        <p className="text-sm text-gray-600 mt-1">
          Monitoring incoming webhook events from httpSMS. Events are displayed in real-time.
        </p>
      </div>
      <div className="flex items-center gap-4">
        <div className="text-sm text-gray-500">
          Last updated: {lastUpdated.toLocaleTimeString()}
        </div>
        <Button 
          variant="outline" 
          size="sm"
          onClick={onRefresh}
          disabled={loading}
          className="flex items-center gap-2"
        >
          <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
      </div>
    </div>
  );
};
